import { FC } from 'react';
import { Amount, Container, Content, Description, Icon } from './DashboardCard.styles';
import {
	TimeToLeaveOutlined,
	AttachMoneyOutlined,
	VisibilityOutlined,
	Money,
	WarningAmberOutlined,
	ThumbDownOutlined,
	ThumbUpOutlined,
	StoreOutlined,
	StorefrontOutlined,
	ApartmentOutlined,
	PeopleOutlined, 
	ReportGmailerrorred,
	AssignmentTurnedInOutlined,
	RequestQuote,
	RequestQuoteOutlined
} from '@mui/icons-material';

export enum DashboardStatus {
	CarsPurchased = 'CarsPurchased',
	ProposalsMade = 'ProposalsMade',
	PaymentsPending = 'PaymentsPending',
	PaymentsPaid = 'PaymentsPaid',
	OpenOffers = 'OpenOffers',
	SoldOffers = 'SoldOffers',
	ClosedOffers = 'ClosedOffers',
	Active = 'Active',
	Inactive = 'Inactive',
	Recused = 'Recused',
	Pending = 'Pending',
	ShopkeeperQty = 'ShopkeeperQty',
	ShopkeeperActiveQty = 'ShopkeeperActiveQty',
	ShopkeeperInactiveQty = 'ShopkeeperInactiveQty',
	GroupDealerQty = 'GroupDealerQty',
	DealerQty = 'DealerQty',
	UserQty = 'UserQty',
	OpenQuotes = 'OpenQuotes',
	MadeQuotes = 'MadeQuotes',
	ClosedQuotes = 'ClosedQuotes',
	Quotes = 'Quotes',
}

const DashboardInfo = {
	[DashboardStatus.CarsPurchased]: {
		icon: <TimeToLeaveOutlined fontSize='inherit' />,
		description: 'Carros comprados',
	},
	[DashboardStatus.PaymentsPending]: {
		icon: <AttachMoneyOutlined fontSize='inherit' />,
		description: 'Pagamentos em aberto',
	},
	[DashboardStatus.PaymentsPaid]: {
		icon: <Money fontSize='inherit' />,
		description: 'Pagamentos pagos',
	},
	[DashboardStatus.ProposalsMade]: {
		icon: <VisibilityOutlined fontSize='inherit' />,
		description: 'Propostas feitas',
	},
	[DashboardStatus.OpenOffers]: {
		icon: <TimeToLeaveOutlined fontSize='inherit' />,
		description: 'Anúncios em aberto',
	},
	[DashboardStatus.SoldOffers]: {
		icon: <AttachMoneyOutlined fontSize='inherit' />,
		description: 'Anúncios vendidos',
	},
	[DashboardStatus.ClosedOffers]: {
		icon: <VisibilityOutlined fontSize='inherit' />,
		description: 'Anúncios encerrados',
	},
	[DashboardStatus.OpenQuotes]: {
		icon: <TimeToLeaveOutlined fontSize='inherit' />,
		description: 'Cotações em aberto',
	},
	[DashboardStatus.MadeQuotes]: {
		icon: <AssignmentTurnedInOutlined fontSize='inherit' />,
		description: 'Cotaçoes encerrados',
	},
	[DashboardStatus.Quotes]: {
		icon: <RequestQuoteOutlined fontSize='inherit' />,
		description: 'Cotações feitas',
	},
	[DashboardStatus.ClosedQuotes]: {
		icon: <VisibilityOutlined fontSize='inherit' />,
		description: 'Cotações vendidas',
	},
	[DashboardStatus.Active]: {
		icon: <ThumbUpOutlined fontSize='inherit' />,
		description: 'Ativos',
	},
	[DashboardStatus.Inactive]: {
		icon: <ThumbDownOutlined fontSize='inherit' />,
		description: 'Inativos',
	},
	[DashboardStatus.Recused]: {
		icon: <WarningAmberOutlined fontSize='inherit' />,
		description: 'Recusados',
	},
	[DashboardStatus.Pending]: {
		icon: <WarningAmberOutlined fontSize='inherit' />,
		description: 'Pendentes',
	},
	[DashboardStatus.ShopkeeperQty]: {
		icon: <StorefrontOutlined fontSize='inherit' />,
		description: 'Lojistas Cadastrados',
	},
	[DashboardStatus.ShopkeeperActiveQty]: {
		icon: <StorefrontOutlined fontSize='inherit' />,
		description: 'Lojistas Ativos',
	},
	[DashboardStatus.ShopkeeperInactiveQty]: {
		icon: <StorefrontOutlined fontSize='inherit' />,
		description: 'Lojistas Inativos',
	},
	[DashboardStatus.GroupDealerQty]: {
		icon: <ApartmentOutlined fontSize='inherit' />,
		description: 'Grupos de Concessionárias',
	},
	[DashboardStatus.DealerQty]: {
		icon: <StoreOutlined fontSize='inherit' />,
		description: 'Concessionárias',
	},
	[DashboardStatus.UserQty]: {
		icon: <PeopleOutlined fontSize='inherit' />,
		description: 'Usuários',
	},
};

interface DashboardCardProps {
	variant: DashboardStatus;
	amount: number;
	onClick?: () => void;
	active?: boolean;
}

const DashboardCard: FC<DashboardCardProps> = ({ variant, amount, onClick, active }) => {
	return (
		<Container $variant={variant} onClick={onClick} $active={active}>
			<Content>
				<Amount>{amount}</Amount>
				<Description>{DashboardInfo[variant].description}</Description>
			</Content>
			<Icon>{DashboardInfo[variant].icon}</Icon>
		</Container>
	);
};

export default DashboardCard;
